"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_BROADCAST = exports.BROADCAST_TOGGLE_BACKGROUND_STATUS = exports.BROADCAST_RELOAD_BANNER = exports.BROADCAST_GET_TEMPLATES = void 0;
var GET_BROADCAST = exports.GET_BROADCAST = 'GET_BROADCAST';
var BROADCAST_RELOAD_BANNER = exports.BROADCAST_RELOAD_BANNER = 'BROADCAST_RELOAD_BANNER';
var BROADCAST_TOGGLE_BACKGROUND_STATUS = exports.BROADCAST_TOGGLE_BACKGROUND_STATUS = 'BROADCAST_TOGGLE_BACKGROUND_STATUS';
var BROADCAST_GET_TEMPLATES = exports.BROADCAST_GET_TEMPLATES = 'BROADCAST_GET_TEMPLATES';